import React, { useState, useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { db, storage } from "../../firebase";
import { collection, addDoc, serverTimestamp, query, getDocs, deleteDoc, doc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

export default function Admin() {
    const [header, setHeader] = useState("");
    const [description, setDescription] = useState("");
    const [category, setCategory] = useState("bajki");
    const [content, setContent] = useState("");
    const [image, setImage] = useState(null);
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const quillRef = useRef(null);

    useEffect(() => {
        fetchPosts();
    }, []);

    const fetchPosts = async () => {
        try {
            const q = query(collection(db, "posts"));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                console.log("Brak postów w Firestore.");

            } else {
                const fetchedPosts = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setPosts(fetchedPosts);
            }
        } catch (error) {
            console.error("Błąd pobierania danych z Firestore: ", error);
            alert(`Błąd pobierania danych: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const handleImageUpload = async () => {
        if (!image) {
            alert("Wybierz plik!");
            return;
        }

        const storageRef = ref(storage, `images/${Date.now()}_${image.name}`);
        try {
            await uploadBytes(storageRef, image);
            const url = await getDownloadURL(storageRef);
            return url;
        } catch (error) {
            console.error("Błąd przesyłania obrazu:", error);
            alert("Wystąpił problem z przesyłaniem obrazu.");
            return null;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!header.trim() || !content.trim()) {
            alert("Tytuł i treść nie mogą być puste!");
            return;
        }

        const imageUrl = await handleImageUpload();
        const slug = header.toLowerCase().replace(/\s+/g, "-");

        try {
            await addDoc(collection(db, "posts"), {
                header,
                description,
                slug,
                category,
                content,
                createdAt: serverTimestamp(),
                imageUrl: imageUrl || "",
            });
            alert("Dodano nowy wpis!");
            setHeader("");
            setDescription("");
            setContent("");
            setImage(null);
            fetchPosts();
        } catch (err) {
            console.error("Błąd zapisu:", err);
            alert("Coś poszło nie tak przy zapisie wpisu.");
        }
    };

    const handleDeletePost = async (postId, imageUrl, title) => {
        const confirmDelete = window.confirm(`Czy na pewno chcesz usunąć bajkę ${title}?`);

        if (!confirmDelete) {
            return;
        }

        try {
            const postRef = doc(db, "posts", postId);
            await deleteDoc(postRef);

            if (imageUrl) {
                const imageRef = ref(storage, imageUrl);
                await deleteObject(imageRef);
            }

            alert("Post usunięty pomyślnie!");
            fetchPosts();
        } catch (error) {
            console.error("Błąd usuwania posta: ", error);
            alert("Coś poszło nie tak przy usuwaniu posta.");
        }
    };

    const renderPosts = () => {
        return posts.map(post => (
            <div key={post.id}>
                <h3>{post.title}</h3>
                <p>{post.description}</p>
                <p>{post.category}</p>
                <p>{post.createdAt?.toDate().toLocaleString()}</p>
                {post.imageUrl && <img src={post.imageUrl} alt="Post Image" style={{width: 100, height: 100}}/>}

                <button onClick={() => handleDeletePost(post.id, post.imageUrl, post.title)}>
                    Usuń bajkę
                </button>
            </div>
        ));
    };

    if (loading) {
        return <p>Ładowanie...</p>;
    }

    return (
        <div className="admin">
            <h2>Nowa bajka / artykuł</h2>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    value={header}
                    onChange={(e) => setHeader(e.target.value)}
                    placeholder="Tytuł"
                    required
                />
                <input
                    type="text"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Krótki opis"
                    required
                />
                <select value={category} onChange={(e) => setCategory(e.target.value)}>
                    <option value="bajki">Bajka</option>
                    <option value="artykuly">Artykuł</option>
                </select>

                <ReactQuill
                    ref={quillRef}
                    value={content}
                    onChange={setContent}
                    theme="snow"
                    placeholder="Treść wpisu..."
                />

                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setImage(e.target.files[0])}
                />

                <button type="submit">Zapisz</button>
            </form>

            <div className="posts-list">
                <h2>Istniejące artykuły i bajki</h2>
                {renderPosts()}
            </div>
        </div>
    );
}
